import dynamic from 'next/dynamic';

import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { useDispatch } from 'react-redux';

import styled from '@emotion/styled';

import Header from '../../src/header/components/Header';
import Footer from '../../src/footer/components/Footer';
import ProductListContainer
  from '../../src/product/list/pc/containers/ProductListContainer';

import useProductListPage from '../../src/product/list/hook/useProductListPage';

import { useAppSelector } from '../../src/shared/store';
import ScrollEventTopButton
  from '../../src/shared/components/Scroll/ScrollEventTopButton';
import MainSiteProvider
  from '../../src/main/components/shared/MainSiteProvider';
import { getMainSiteFromQueryString } from '../../src/product/list/shared/util/getMainSiteFromQueryString';
import { PAGE_TYPE } from '../../src/product/list/constants';
import { productMenuUpdate } from '../../src/product/list/slice';

const FloatingNavigator = dynamic(
  () => import('../../src/navigator/components/FloatingNavigator'),
  { ssr: false },
);

const Body = styled.div`
  padding-bottom: 80px;
`;

const Container = styled.div`
  position: relative;
  padding-bottom: 80px;
`;

export default function ListPage() {
  const { pageUpdate } = useProductListPage({
    device: 'pc',
  });

  const { hasSession } = useAppSelector(({ auth }) => auth);
  const { section, isLoading } = useAppSelector(({ productList }) => productList);
  const dispatch = useDispatch();
  const router = useRouter();
  const { query } = router;
  const { site } = query as { site: string; };
  const mainSite = getMainSiteFromQueryString(site);

  const subMenuChange = (code: string) => {
    dispatch(productMenuUpdate(code));

    const pageType = PAGE_TYPE.find((it) => it.type === section);
    if (!pageType) {
      return;
    }

    const url = `${router.pathname}?${pageType.code}=${code}${mainSite === 'BEAUTY' ? '&site=beauty' : ''}`;
    router.replace(url);
  };

  useEffect(() => {
    if (!hasSession) {
      return;
    }

    pageUpdate();
  }, [hasSession, pageUpdate, router.asPath]);

  return (
    <MainSiteProvider site={mainSite}>
      <Header />
      <Body>
        <Container>
          <ScrollEventTopButton>
            <ProductListContainer onSubMenuChange={subMenuChange} />
          </ScrollEventTopButton>
          <FloatingNavigator isTopInitial={isLoading} />
        </Container>
      </Body>
      <Footer />
    </MainSiteProvider>
  );
}
